import React, { useState,useEffect } from "react";
import Paper from "@mui/material/Paper";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Advistory.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../../../components/footer/Footer.js";
import TopButton from "../../../components/topButton/TopButton.js";
import Navigationbar from "../../../components/header/Navigationbar.jsx";
import Model from "../../../containers/Model/Model.jsx";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../../contact/WhatsAppCard.jsx";

const Advistory = (props) => {
  const theme = props.theme;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };

  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }
    

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);
  return (
    <div className="educaton-main">
      <Navigationbar theme={theme} />
      <Paper elevation={4}>
        <div className="basic-education1">
          <Model open={isModalOpen} onClose={handleCloseModal} />
          <div className="basic-education-services">
            <div className="advistory-realestate">
            {isScrollingUp && animationShown ? (
              <> 
              <div className="advistory-realestate-text">
                <p className="advistory-realestate-text-header">
                  Real Estate Advisory
                </p>
                <p className="advistory-realestate-text-main">
                  Equities represent ownership in a company and are commonly
                  known as stocks or shares.Shareholders have ownership rights,
                  entitling them to a portion of the company's assets and
                  earnings.Returns on equities include dividends and capital
                  appreciation.Equity investments carry market risk, and returns
                  are tied to the company's performance.
                </p>
                <p className="advistory-realestate-text-main">
                  Derivatives are financial contracts whose value is derived
                  from an underlying asset, index, or reference rate.Includes
                  options, futures, swaps, and forwards.Derivatives are used for
                  risk management, speculation, and hedging.Derivatives often
                  allow investors to control a larger position with a smaller
                  upfront investment.
                </p>
              </div>
              </>
            ) : (
              <Zoom>
                <div className="advistory-realestate-text">
                <p className="advistory-realestate-text-header">
                  Real Estate Advisory
                </p>
                <p className="advistory-realestate-text-main">
                  Equities represent ownership in a company and are commonly
                  known as stocks or shares.Shareholders have ownership rights,
                  entitling them to a portion of the company's assets and
                  earnings.Returns on equities include dividends and capital
                  appreciation.Equity investments carry market risk, and returns
                  are tied to the company's performance.
                </p>
                <p className="advistory-realestate-text-main">
                  Derivatives are financial contracts whose value is derived
                  from an underlying asset, index, or reference rate.Includes
                  options, futures, swaps, and forwards.Derivatives are used for
                  risk management, speculation, and hedging.Derivatives often
                  allow investors to control a larger position with a smaller
                  upfront investment.
                </p>
              </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="advistory-realestate-card-main">
                  <div className="advistory-realestate-card">
                    <img
                      src='/assets/images/Realestateadvisory.jpg'
                      className="advistory-realestate-card-img-top"
                      alt="..."
                    />
                    <div className="advistory-realestate-card-body">
                      <h5
                        className="advistory-realestate-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Real Estate Advisory
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="advistory-realestate-card-main">
                  <div className="advistory-realestate-card">
                    <img
                      src='/assets/images/Realestateadvisory.jpg'
                      className="advistory-realestate-card-img-top"
                      alt="..."
                    />
                    <div className="advistory-realestate-card-body">
                      <h5
                        className="advistory-realestate-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Real Estate Advisory
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Zoom>
              )}
            </div>
            <div className="advistory-mortgage">
              {isScrollingUp && animationShown ? (
              <> 
                <div className="advistory-mortgage-card-main">
                  <div className="advistory-mortgage-card">
                    <img
                      src='/assets/images/Mortgageadvisory.jpg'
                      className="advistory-mortgage-card-img-top"
                      alt="..."
                    />
                    <div className="advistory-mortgage-card-body">
                      <h5
                        className="advistory-mortgage-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Mortgage Advisory
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              ) : (
              <Zoom>
                <div className="advistory-mortgage-card-main">
                <div className="advistory-mortgage-card">
                  <img
                    src='/assets/images/Mortgageadvisory.jpg'
                    className="advistory-mortgage-card-img-top"
                    alt="..."
                  />
                  <div className="advistory-mortgage-card-body">
                    <h5
                      className="advistory-mortgage-card-title"
                      style={{ paddingBottom: "10px" }}
                    >
                      Mortgage Advisory
                    </h5>
                    <div
                      className="cardbutton"
                      style={{ display: "flex", gap: "20px" }}
                    >
                      <button
                        className="broking-applynow"
                        onClick={handleOpenModal}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </Zoom>
              )}
              {isScrollingUp && animationShown ? (
              <>
                <div className="advistory-mortgage-text">
                  <p className="advistory-mortgage-text-header">
                    CommodMortgage Advisoryity
                  </p>
                  <p className="advistory-mortgage-text-main">
                    Commodity finance refers to the financial instruments and
                    services designed to facilitate the production, trade, and
                    consumption of physical goods, known as commodities. This area
                    of finance plays a crucial role in supporting the global
                    supply chain for raw materials and primary goods.
                  </p>
                  <p className="advistory-mortgage-text-main">
                    Involves providing funding and financial instruments to
                    facilitate the buying and selling of commodities
                    internationally.Financing to help businesses hold and manage
                    their commodity inventories.Hedging tools are often employed
                    to mitigate price volatility and currency risks associated
                    with commodity transactions.
                  </p>
                </div>
              </>
              ) : (
                <Zoom>
                  <div className="advistory-mortgage-text">
                    <p className="advistory-mortgage-text-header">
                      CommodMortgage Advisoryity
                    </p>
                    <p className="advistory-mortgage-text-main">
                      Commodity finance refers to the financial instruments and
                      services designed to facilitate the production, trade, and
                      consumption of physical goods, known as commodities. This area
                      of finance plays a crucial role in supporting the global
                      supply chain for raw materials and primary goods.
                    </p>
                    <p className="advistory-mortgage-text-main">
                      Involves providing funding and financial instruments to
                      facilitate the buying and selling of commodities
                      internationally.Financing to help businesses hold and manage
                      their commodity inventories.Hedging tools are often employed
                      to mitigate price volatility and currency risks associated
                      with commodity transactions.
                    </p>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="advistory-wealth">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="advistory-wealth-text">
                    <p className="advistory-wealth-text-header">
                      Wealth Management
                    </p>
                    <p className="advistory-wealth-text-main">
                      Currency finance, also known as forex finance or foreign
                      exchange finance, refers to financial activities and
                      instruments that involve the exchange of currencies. It plays
                      a pivotal role in international trade, investment, and
                      financial markets.{" "}
                    </p>
                    <p className="advistory-wealth-text-main">
                      The buying and selling of currencies to take advantage of
                      fluctuations in exchange rates.Strategies employed by
                      businesses and investors to mitigate the risks associated with
                      currency fluctuations.Financial instruments such as currency
                      futures and options used for speculative and hedging purposes.
                    </p>
                  </div>
                </>
              ) : (
              <Zoom>
                <div className="advistory-wealth-text">
                  <p className="advistory-wealth-text-header">
                    Wealth Management
                  </p>
                  <p className="advistory-wealth-text-main">
                    Currency finance, also known as forex finance or foreign
                    exchange finance, refers to financial activities and
                    instruments that involve the exchange of currencies. It plays
                    a pivotal role in international trade, investment, and
                    financial markets.{" "}
                  </p>
                  <p className="advistory-wealth-text-main">
                    The buying and selling of currencies to take advantage of
                    fluctuations in exchange rates.Strategies employed by
                    businesses and investors to mitigate the risks associated with
                    currency fluctuations.Financial instruments such as currency
                    futures and options used for speculative and hedging purposes.
                  </p>
                </div>
              </Zoom>
              )}
              {isScrollingUp && animationShown ? (
              <>
                <div className="advistory-wealth-card-main">
                  <div className="advistory-wealth-card">
                    <img
                      src='/assets/images/Wealthmanagement.jpg'
                      className="advistory-wealth-card-img-top"
                      alt="..."
                    />
                    <div className="advistory-wealth-card-body">
                      <h5
                        className="advistory-wealth-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Wealth Management
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              ) : (
                <Zoom>
                <div className="advistory-wealth-card-main">
                  <div className="advistory-wealth-card">
                    <img
                      src='/assets/images/Wealthmanagement.jpg'
                      className="advistory-wealth-card-img-top"
                      alt="..."
                    />
                    <div className="advistory-wealth-card-body">
                      <h5
                        className="advistory-wealth-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Wealth Management
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                </Zoom>
              )}
            </div>
            <div className="advistory-portfolio">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="advistory-portfolio-card-main">
                    <div className="advistory-portfolio-card">
                      <img
                        src='/assets/images/Portfoliomanagement.jpg'
                        className="advistory-portfolio-card-img-top"
                        alt="..."
                      />
                      <div className="advistory-portfolio-card-body">
                        <h5
                          className="advistory-portfolio-card-title"
                          style={{ paddingBottom: "10px" }}
                        >
                          {" "}
                          Portfolio Management
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="advistory-portfolio-card-main">
                    <div className="advistory-portfolio-card">
                      <img
                        src='/assets/images/Portfoliomanagement.jpg'
                        className="advistory-portfolio-card-img-top"
                        alt="..."
                      />
                      <div className="advistory-portfolio-card-body">
                        <h5
                          className="advistory-portfolio-card-title"
                          style={{ paddingBottom: "10px" }}
                        >
                          {" "}
                          Portfolio Management
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="advistory-portfolio-text">
                    <p className="advistory-portfolio-text-header">
                      Portfolio Management
                    </p>
                    <p className="advistory-portfolio-text-main">
                      Depository finance refers to financial services and activities
                      related to the establishment and management of depositories. A
                      depository is an organization or institution that holds and
                      facilitates the transfer of financial securities, providing a
                      secure and efficient platform for investors and market
                      participants.
                    </p>
                    <p className="advistory-portfolio-text-main">
                      Safeguarding and holding financial securities in electronic
                      form, eliminating the need for physical
                      certificates.Facilitating the settlement of trades by
                      transferring ownership of securities between buyers and
                      sellers.Converting physical securities into electronic form to
                      enable efficient electronic trading and management.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="advistory-portfolio-text">
                    <p className="advistory-portfolio-text-header">
                      Portfolio Management
                    </p>
                    <p className="advistory-portfolio-text-main">
                      Depository finance refers to financial services and activities
                      related to the establishment and management of depositories. A
                      depository is an organization or institution that holds and
                      facilitates the transfer of financial securities, providing a
                      secure and efficient platform for investors and market
                      participants.
                    </p>
                    <p className="advistory-portfolio-text-main">
                      Safeguarding and holding financial securities in electronic
                      form, eliminating the need for physical
                      certificates.Facilitating the settlement of trades by
                      transferring ownership of securities between buyers and
                      sellers.Converting physical securities into electronic form to
                      enable efficient electronic trading and management.
                    </p>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="advistory-investment">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="advistory-investment-text">
                    <p className="advistory-investment-text-header">
                      Investment Banking
                    </p>
                    <p className="advistory-investment-text-main">
                      Clearing in finance refers to the process of settling
                      financial transactions and ensuring the smooth transfer of
                      assets between buyers and sellers in a financial market. It
                      plays a crucial role in facilitating transparent and efficient
                      trading.
                    </p>
                    <p className="advistory-investment-text-main">
                      An institution or organization that acts as a central
                      counterparty (CCP) to clear and settle trades.Financial
                      institutions that are members of the clearinghouse and
                      facilitate the clearing process for their clients.The
                      clearinghouse verifies and matches the details of trades
                      submitted by market participants.
                    </p>
                  </div>
                </>
              ) : (
              <Zoom>
                <div className="advistory-investment-text">
                <p className="advistory-investment-text-header">
                  Investment Banking
                </p>
                <p className="advistory-investment-text-main">
                  Clearing in finance refers to the process of settling
                  financial transactions and ensuring the smooth transfer of
                  assets between buyers and sellers in a financial market. It
                  plays a crucial role in facilitating transparent and efficient
                  trading.
                </p>
                <p className="advistory-investment-text-main">
                  An institution or organization that acts as a central
                  counterparty (CCP) to clear and settle trades.Financial
                  institutions that are members of the clearinghouse and
                  facilitate the clearing process for their clients.The
                  clearinghouse verifies and matches the details of trades
                  submitted by market participants.
                </p>
              </div>
              </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="advistory-investment-card-main">
                    <div className="advistory-investment-card">
                      <img
                        src='/assets/images/Investmentbanking.jpg'
                        className="advistory-investment-card-img-top"
                        alt="..."
                      />
                      <div className="advistory-investment-card-body">
                        <h5
                          className="advistory-investment-card-title"
                          style={{ paddingBottom: "10px" }}
                        >
                          Investment Banking
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="advistory-investment-card-main">
                    <div className="advistory-investment-card">
                      <img
                        src='/assets/images/Investmentbanking.jpg'
                        className="advistory-investment-card-img-top"
                        alt="..."
                      />
                      <div className="advistory-investment-card-body">
                        <h5
                          className="advistory-investment-card-title"
                          style={{ paddingBottom: "10px" }}
                        >
                          Investment Banking
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                </div>
                </Zoom>
              )}
            </div>
            <div className="advistory-forex">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="advistory-forex-card-main">
                    <div className="advistory-forex-card">
                      <img
                        src='/assets/images/Forexadvisory.avif'
                        className="advistory-forex-card-img-top"
                        alt="..."
                      />
                      <div className="advistory-forex-card-body">
                        <h5
                          className="advistory-forex-card-title"
                          style={{ paddingBottom: "10px" }}
                        >
                          Forex Advisory
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="advistory-forex-card-main">
                    <div className="advistory-forex-card">
                      <img
                        src='/assets/images/Forexadvisory.avif'
                        className="advistory-forex-card-img-top"
                        alt="..."
                      />
                      <div className="advistory-forex-card-body">
                        <h5
                          className="advistory-forex-card-title"
                          style={{ paddingBottom: "10px" }}
                        >
                          Forex Advisory
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="advistory-forex-text">
                    <p className="advistory-forex-text-header">Forex Advisory</p>
                    <p className="advistory-forex-text-main">
                      Institutional finance refers to the provision of financial
                      services and products to large entities, such as corporations,
                      government agencies, and other institutions, by specialized
                      financial institutions. This type of finance caters to the
                      unique needs and complexities of these entities, offering a
                      range of services beyond those provided to individual
                      consumers.{" "}
                    </p>
                    <p className="advistory-forex-text-main">
                      {" "}
                      Banks, investment banks, insurance companies, and other
                      specialized financial entities that offer services tailored to
                      institutional clients.Entities such as pension funds, mutual
                      funds, hedge funds, and sovereign wealth funds that manage
                      large pools of capital on behalf of their constituents.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="advistory-forex-text">
                    <p className="advistory-forex-text-header">Forex Advisory</p>
                    <p className="advistory-forex-text-main">
                      Institutional finance refers to the provision of financial
                      services and products to large entities, such as corporations,
                      government agencies, and other institutions, by specialized
                      financial institutions. This type of finance caters to the
                      unique needs and complexities of these entities, offering a
                      range of services beyond those provided to individual
                      consumers.{" "}
                    </p>
                    <p className="advistory-forex-text-main">
                      {" "}
                      Banks, investment banks, insurance companies, and other
                      specialized financial entities that offer services tailored to
                      institutional clients.Entities such as pension funds, mutual
                      funds, hedge funds, and sovereign wealth funds that manage
                      large pools of capital on behalf of their constituents.
                    </p>
                  </div>
                </Zoom>
              )}
            </div>
          </div>
        </div>
      </Paper>
      <Footer theme={props.theme} onToggle={props.onToggle} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </div>
  );
};

export default Advistory;
